import React from 'react'
import Links from '../../components/links/links';

const PautasNavegacion = () => {
  return (
    <section>
      <div className='tw-mt-8 tw-mt-8@lg tw-mb-8 tw-mb-8@lg'>
        <h2 className='font-family-secondary c-gray--4 fw-7 tw-m-0 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-4@lg'>
          Pautas para una navegación segura
        </h2>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          No olvides tener en cuenta que:
        </p>
        <div className='c-gray--4 left tw-mb-4 tw-mb-4@lg'>
          <ul className={`w-100 bulletList-0 font-family-primary tw-f-16 tw-f-16@lg tw-mt-2`}>
            <li className='tw-mb-2'>
              Nuestra página web puede ofrecer links o acceso a otros sitios webs que no son 
              parte de Prima AFP. Por eso, te recomendamos revisar cuidadosamente las políticas 
              de privacidad en dichas páginas web ya que pueden ser distintas a nuestras 
              Políticas de Privacidad.
            </li>
            <li>
              Nuestra Política de Privacidad está en constante evolución. En Prima AFP 
              mejoramos continuamente nuestros procesos, por lo que podríamos realizar 
              modificaciones y correcciones. Recuerda visitar este sitio para consultar 
              los cambios realizados. Siempre eres bienvenido.
            </li>
          </ul>
        </div>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Para cualquier duda relacionada con la presente Política de Privacidad, puedes 
          ponerte en contacto con nosotros a través de nuestra página web{' '}
          <a
            className='c-orange-0 b underline'
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.prima.com.pe'
          >
            www.prima.com.pe
          </a>{' '}o de nuestra central telefónica llamando al <span className='c-turquoise-0 b'>(01) 615-7272 </span> 
          si te encuentras en Lima o al <span className='c-turquoise-0 b'>0-801-18010</span> si te encuentras en 
          provincia.
        </p>
      </div>
    </section>
  )
}

export default PautasNavegacion
